export enum ForumEndpoints {
	Create = '/blokforums',
	Update = '/blokforums/:id',
	Delete = '/blokforums/:id',
	FetchOneBy = '/blokforums/:forumSlug',
	FetchInfoBy = '/blokforums/info/:forumSlug',
	FetchAllByOwnerId = '/blokforums/by/:blokId',
}
